import {
    Paragraph,
    patchDocument, PatchType, ShadingType, Table, TableCell, TableRow,
    TextRun, WidthType
} from "docx";
import Moment from 'moment';
import {addBusinessDays} from "./date";
import 'moment/locale/de';
import {formatToPrice} from "./finances";


Moment.locale('de');


const createDocx = (templateFile, firstname, lastname, street, houseNumber, zip, city, sepa, basicPrice, inputRows, totalPrice, creationDate) => {

    // basic monthly price is always added as first row
    const firstRow = new TableRow({
        children: [
            new TableCell({
                children: [],
            }),
            new TableCell({
                children: [new Paragraph({
                    children: [
                        new TextRun({text: "Rund um die Uhr Betreuung", size: 20})
                    ]
                })],
            }),
            new TableCell({
                children: [new Paragraph({
                    children: [
                        new TextRun({text: Moment(creationDate).format("MMM YYYY"), size: 20})
                    ]
                })],
            }),
            new TableCell({
                children: [],
            }),
            new TableCell({
                children: [],
            }),
            new TableCell({
                children: [new Paragraph({
                    children: [
                        new TextRun({text: formatToPrice(basicPrice), size: 20})
                    ]
                })],
            }),
        ],
    })

    const documentRows = [firstRow];

    for (const inputRow of inputRows) {
        const newCells = [
            new TableCell({
                children: [new Paragraph({
                    children: [
                        new TextRun({text: inputRow.service.additional ? "Zuzüglich" : "Abzüglich", size: 20})
                    ]
                })],
            }),
            new TableCell({
                children: [new Paragraph({
                    children: [
                        new TextRun({text: inputRow.service.label, size: 20})
                    ]
                })],
            }),
            new TableCell({
                children: [],
            }),
            new TableCell({
                children: inputRow.amount === null ? [] : [
                    new Paragraph({
                        children: [
                            new TextRun({text: inputRow.amount.toString(), size: 20})
                        ]
                    })
                ],
            }),
            new TableCell({
                children: inputRow.unitPrice === null ? [] : [
                    new Paragraph({
                        children: [
                            new TextRun({text: formatToPrice(inputRow.unitPrice.toString()), size: 20})
                        ]
                    })
                ],
            }),
            new TableCell({
                children: inputRow.totalPrice === null ? [] : [
                    new Paragraph({
                        children: [
                            new TextRun({text: formatToPrice(inputRow.totalPrice.toString()), size: 20})
                        ]
                    })
                ],
            }),
        ];
        const newRow = new TableRow({children: newCells});
        documentRows.push(newRow);
    }

    console.log(documentRows);

    // table header style
    const shadingFill = "cfcfcf";
    const shadingType = ShadingType.PERCENT_10;
    const shadingColor = "auto";

    const tableContent = new Table({
        rows: [
            new TableRow({
                tableHeader: true,
                children: [
                    new TableCell({
                        children: [],
                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Leistung", size: 20})
                            ]
                        })],
                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Zeitraum", size: 20})
                            ]
                        })],
                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Menge", size: 20})
                            ]
                        })],

                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Einzelp. (€)", size: 20})
                            ]
                        })],
                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Gesamtp. (€)", size: 20})
                            ]
                        })],
                        shading: {
                            fill: shadingFill,
                            type: shadingType,
                            color: shadingColor,
                        },
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 6,
                        children: [new Paragraph({
                            children: [
                                new TextRun({text: "Zeitraum: " + Moment(creationDate).format("MMMM YYYY"), size: 20})
                            ]
                        })],
                    }),
                ],
            }),
            ...documentRows
        ],
        width: { size: 100, type: WidthType.PERCENTAGE },
        columnWidths: [11,31,13,8,13,14]
    })

    return patchDocument({
        outputType: "nodebuffer",
        data: templateFile,
        patches: {
            firstname: {
                type: PatchType.PARAGRAPH,
                    children: [new TextRun(firstname)],
            },
            lastname: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(lastname)],
            },
            street: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(street)],
            },
            house_number: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(houseNumber)],
            },
            zip: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(zip.toString())],
            },
            city: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(city)],
            },
            mm_yy: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(Moment(creationDate).format("MM/yy"))],
            },
            date: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(Moment(creationDate).format("DD.MM.yyyy"))],
            },
            sepa: {
                type: PatchType.PARAGRAPH,
                children: sepa ? [new TextRun("Der Betrag wird am " + addBusinessDays(Moment(creationDate), 4).format("DD.MM.yyyy") +" via SEPA Mandat von Ihrem Konto abgebucht.")] : [],
            },
            table: {
                type: PatchType.DOCUMENT,
                children: [tableContent],
            },
            total_price: {
                type: PatchType.PARAGRAPH,
                children: [new TextRun(formatToPrice(totalPrice.toString()))]
            }
        },
    });
}

export default createDocx;
